import FocusObserver from './focus-observer.container';
import * as Reducer from './focus-observer.reducer';

export { FocusObserver, Reducer };

export default FocusObserver;
